module.exports = __webpack_public_path__ + "static/media/error.36339f33.svg";